<template>
  <div class="networking-block">
    <transition-group name="list-complete" class="networking-block" mode="out-in">
      <div class="networking list-complete-item" v-for="item in data" :key="item.id" @click="item.users.length < item.peopleCount ? $store.dispatch('joinRoom', item.id) : ''">
        <img class="networking-header" v-if="item.cover != null" :src="$imageus + item.cover + '?width=460&height=205&mode=cover'" alt="" />
        <img class="session-header" v-if="item.cover == null" src="/static/1120x500.png" alt="" />

        <div class="networking-users">
          <template v-for="peopleIndex in item.peopleCount">
            <div
              class="chair"
              @click="$root.$emit('getProfile', item.users[peopleIndex - 1].id)"
              v-if="item.users != null && item.users[peopleIndex - 1] != undefined"
              :style="item.users[peopleIndex - 1].image != null ? 'background-image: url(' + $imageus + item.users[peopleIndex - 1].image + '?width=50&height=50&mode=cover)' : 'background-color : ' + currentEvent.color + ';background-image: url(/static/menuicons/user-no-picture.svg); background-position: 50% 45%; background-repeat: no-repeat; background-size: 14px 14px;'"
              :title="item.users[peopleIndex - 1].firstName"
              :key="peopleIndex"
            >
              <md-tooltip md-direction="top" :key="'toolltip-' + item.id">{{ item.users[peopleIndex - 1].firstName }} {{ item.users[peopleIndex - 1].lastName }}</md-tooltip>
            </div>
          </template>
        </div>

        <div class="networking-card">
          <div class="networking-left">
            <div class="networking-info">
              <span v-if="item.users.length >= item.peopleCount" style="color: #f22f2f;">
                <img src="/static/menuicons/lock-closed-sharp.svg" />
                {{ $t("networking.lock_closed") }} ● {{ item.peopleCount }} / {{ item.users.length }}
              </span>
              <span v-if="item.users.length < item.peopleCount" style="color: #268EA6;">
                <img src="/static/menuicons/lock-open-sharp.svg" />
                {{ $t("networking.lock_open") }} ● {{ item.peopleCount }} / {{ item.users.length }}
              </span>
            </div>

            <div class="networking-title">
              <p>{{ item.title }}</p>
            </div>
          </div>

          <div class="networking-right">
            <el-button :icon="$store.state.sessionLoadingID != item.id ? 'fas fa-angle-right' : 'fas fa-spinner spin'" :style="{ backgroundColor: currentEvent.color }" size="mini" circle></el-button>

            <!-- <button :style="item.users.length < item.peopleCount ? 'background-color: ' + currentEvent.color : 'background-color: #8C929C'"> -->
            <!-- <span v-if="$store.state.sessionLoadingID != item.id"><i class="fas fa-angle-right"></i></span> -->
            <!-- <span v-if="$store.state.sessionLoadingID == item.id"><i class="fas fa-spinner spin"></i></span> -->
            <!-- <md-progress-spinner style="transition: 0s !important;" v-if="$store.state.sessionLoadingID == item.id" class="md-accent" :md-diameter="15" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner> -->
            <!-- </button> -->
          </div>
        </div>
        <!-- <md-tooltip md-direction="top" :key="'toolltip-' + item.id">{{ item.title }}</md-tooltip> -->
      </div>
    </transition-group>
  </div>
</template>

<script>
import moment from "moment/min/moment-with-locales";

export default {
  name: "NetworkingBlock",
  props: ["data"],
  data() {
    return {
      moment
    };
  },

  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    }
  }
};
</script>

<style lang="less">
.networking-block {
  display: contents;
  cursor: pointer;

  .networking {
    width: 100%;
    position: relative;

    h4,
    h5 {
      margin: 0;
    }

    .networking-users {
      position: absolute;
      top: 10px;
      left: 12px;
      display: flex;
      flex-direction: row;

      .chair {
        width: 35px;
        height: 35px;
        background: white;
        border-radius: 50%;
        border: 2px solid #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        background-position: center;
        background-size: cover;
        margin-left: 0px;
        &:hover {
          background-color: #333;
          cursor: pointer;
        }

        &:not(:first-child) {
          margin-left: -16px !important;
        }
      }
    }

    .networking-header {
      width: 100%;
      height: auto;
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
    }

    .networking-card {
      justify-content: space-around;
      flex-direction: row;
      align-items: center;
      display: flex;
      background-color: #fff;
      padding: 8px 10px;
      // border: 0.5px solid #D6D9D9;
      box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
      border-top: none;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;

      .networking-left {
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: center;
        margin-left: 6px;

        .networking-info {
          margin: 0px;

          span {
            color: #8c929c;
            font-size: 12px;
            font-weight: 500;
            img {
              width: 12px;
              height: 12px;
              margin-right: 4px;
              margin-bottom: 4px;
            }
          }
        }

        .networking-title {
          line-height: 16px;
          display: inline-grid;

          p {
            text-overflow: ellipsis;
            max-width: 220px !important;
            white-space: nowrap;
            overflow: hidden;
            margin: 0px;
            display: block;
            color: #292f3b;
            font-weight: 500;
            font-size: 14px;
          }
        }
      }

      .networking-right {
        // button {
        //   border: none;
        //   outline: none;
        //   padding: 8px 15px;
        //   background-color: whitesmoke;
        //   font-weight: bold;
        //   color: white;
        //   margin-left: 15px;
        //   border-radius: 16px;
        //   font-family: "Roboto";
        //   cursor: pointer;
        // }
        flex-shrink: 0;
        .el-button {
          flex-shrink: 0;
          font-family: "Roboto";
          color: #fff;
          border: none;
          outline: none;
          width: 26px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/NetworkingBlock.vue